module.exports = __webpack_public_path__ + "static/media/spilceOne@2x.3988e825.png";